<template>
  <v-card elevation="0">
    <v-row justify="space-between">
      <v-col cols="6" class="py-0">
        <v-card-title primary-title>New Conditions</v-card-title>
      </v-col>
    </v-row>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-text-field
            class="py-0"
            v-model="search"
            label="Search"
            append-icon="mdi-search"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-data-table
      :headers="headers"
      :items="tableData"
      :search="search"
      :sort-by="['CLAIM_DATE']"
      :sort-desc="[true]"
      :footer-props="{
        'items-per-page-options': [25, 50, 75, 100, -1],
      }"
      :items-per-page="25"
      @update:pagination="getMore()"
      multi-sort
      loading-text="Loading data..."
      class="elevation-0 col-md-12 m-auto"
    >
      <template v-slot:item.DETAILS="{ item }">
        <patient-modal :patient="{ ID: item.PATIENT_ID }" :insurance="insurance" />
      </template>

      <template slot="footer">
        <ExportCSV :data="this.tableData" :name="'New Conditions ' + this.startDate + '.csv'">
          <v-btn color="secondary" text small class="export-button">Export to CSV</v-btn>
        </ExportCSV>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios';
import ExportCSV from 'vue-json-csv';
import PatientModal from '../PatientModal';

export default {
  name: 'NewConditions',
  props: ['reportData', 'insurance', 'startDate'],
  components: {
    PatientModal,
    ExportCSV,
  },
  data() {
    return {
      search: '',
      user: '',
      pagination: '',
      tableData: [],
      headers: [
        { text: 'Patient', value: 'PATIENT_NAME' },
        // { text: 'DOB', value: 'DOB' },
        { text: 'Provider', value: 'PCP_NAME' },
        { text: 'Servicer', value: 'GROUP_NAME' },
        { text: 'Date', value: 'CLAIM_DATE' },
        { text: 'Codes', value: 'CODE' },
        { text: 'HCC Category', value: 'HCC_CATEGORY' },
        { text: 'HCC Description', value: 'HCC_DESCIRPTION' },
        { text: 'Details', value: 'DETAILS' },
      ],
    };
  },
  mounted() {},
  methods: {},
  watch: {
    reportData() {
      this.tableData = this.reportData;
    },
  },
};
</script>

<style scoped>
.export-button {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
